module.exports = __webpack_public_path__ + "static/media/programmer.384ba127.svg";